module.exports = __webpack_public_path__ + "d664201f/img/note-list-icon.961c1485.svg";